var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ei-type-writer",style:({'--height':_vm.height+'px',
     '--fontSize':_vm.fontsize+'px',
     '--length':_vm.length,
     '--duration':_vm.length*_vm.speed+'s'})},[_vm._v(" "+_vm._s(_vm.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }